<template>
  <div class="page">
    <div class="page-container">
      <project-page-header ref="pageHeader" :id="projectId"></project-page-header>
      <div class="page-title">财务请款单</div>
      <div class="panel-body">
        <div class="panel-info-section relative-position w1000">
          <table class="table table-plain">
            <tbody>
              <tr>
                <th>实际请款金额</th>
                <td><b class="text-indigo">{{ $utils.thousands(record.applyAmount) }}</b> 元</td>
                <th>付款申请日期</th>
                <td>{{ record.applyDate }}</td>
              </tr>
              <tr>
                <th>捐赠物品和服务说明</th>
                <td colspan="3">{{ record.serviceDesc }}</td>
              </tr>
              <tr>
                <th>捐赠物品及服务公允值</th>
                <td colspan="3">{{ $utils.thousands(record.serviceFairValue) }} 元</td>
              </tr>
              <tr>
                <th>收款单位</th>
                <td colspan="3">{{ record.billTitle }}</td>
              </tr>
              <tr>
                <th width="200">开户行</th>
                <td>{{ record.bankName }}</td>
                <th width="160">银行账号</th>
                <td>{{ record.bankCard }}</td>
              </tr>
              <tr>
                <th>捐赠凭证</th>
                <td colspan="3">
                  <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="check-img" v-if="[1, 2, 3, 4].includes(record.state)">
            <img src="~@/assets/images/audit.png" />
          </div>
        </div>
        <div class="text-center v-my-lg">
          <a-space>
            <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { getApplyBill } from '@/api/project/common'
export default {
  name: 'FundedProjectApplyBill',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      applyId: this.$route.query.aid,
      loading: false,
      record: {},
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, aid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (aid) {
        this.applyId = +aid
        this.loadApplyBill()
      }
    },
    loadApplyBill() {
      this.loading = true
      getApplyBill(this.applyId).then(({ data }) => {
        if (data.success) {
          this.record = data.result
        }
        this.loading = false
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
